import { lazy } from 'react';

import { whatsappTemplatesTranslations as enTemplates } from '@/lang/en/whatsappTemplates';
import { whatsappTemplatesTranslations as esTemplates } from '@/lang/es/whatsappTemplates';
import { whatsappTemplatesTranslations as ptTemplates } from '@/lang/pt/whatsappTemplates';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

import { whatsappTemplatesSlice } from './domain/state/whatsappTemplatesSlice';

const WhatsappTemplatesNavigation = lazy(() =>
  import('./WhatsappTemplatesNavigation').then((m) => ({
    default: m.WhatsappTemplatesNavigation,
  })),
);

/** WhatsApp message templates: CRUD, variables, sending. */
export const whatsappTemplatesModule: FeatureModule = {
  id: 'whatsapp-templates',
  routes: [
    { path: 'templates/*', to: '/app/templates', Component: WhatsappTemplatesNavigation },
  ],
  nav: [
    {
      sectionId: 'main',
      order: 40,
      to: '/app/templates',
      label: label('global', 'sidebar_templates_label'),
    },
  ],
  slices: [whatsappTemplatesSlice],
  i18n: namespaceBundle('whatsappTemplates', {
    es: esTemplates,
    en: enTemplates,
    pt: ptTemplates,
  }),
};
